import React from 'react'
import Bredcom from '../Bredcom/Main'
import First from '../Mencontact/First'

function Main() {
  return (
    <>
        <Bredcom title="Contact Us" subtitle="Home" subtitledown="Contact Us" />
        <First/>
    </>
  )
}

export default Main